import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {i18n,formatNumber} from '../../Utility/Format';
import Icon from '../Helper/Icon';

const isNotANumber = value => {

    if (null == value) {
        return true;
    }

    return 'string' === typeof value;
};

/**
 * Display a given number in different colors and with different icons depending on its algebraic sign
 */
const CurrencyChangeValue = (props) => {
    const value = props.value;
    let showIcon = props.showIcon;
    let fractionDigits = props.fractionDigits;
    let unit = props.unit;
    let iconName = 'circle';
    let showText=props.showText;
let text='';
    if (isNotANumber(value)) {
        showIcon = false;
        unit = false;
        showText =false;
    } else if (value < 0) {
        iconName = 'triangle-down';
        text=i18n('dbm.currency.lossStatus');

        
    } else if (value > 0) {
        iconName = 'triangle-up';
        
        text=i18n('dbm.currency.gainStatus');
    
    } else if (value === 0) {
        fractionDigits = 0;
        unit = false;
       }

    const className = classnames('currency-change-value', {
        'currency-change-value--positive': value > 0,
        'currency-change-value--negative': value < 0,
        'currency-change-value--unchanged': value === 0
    });

    return (
       
        <div className={className}>
                          {showText ? <span>{text}</span> : null}  
                        
            {
                showIcon ?  <Icon name={iconName} isCollapsed={true}/> : null} 
             <span className="value">{isNotANumber(value) ? '–' : formatNumber(value, fractionDigits)}</span>
            {unit ? <span className="unit">{unit}</span> : null
            } 
</div>
    );
};

CurrencyChangeValue.propTypes = {
    value: PropTypes.number,
    unit: PropTypes.string,
    showIcon: PropTypes.bool,
    showText:PropTypes.bool
};

export default CurrencyChangeValue;